import { useWindowDimensions } from "@-/com.npmjs.react-native";

export function useRootContextValue() {
  const windowDimensions = useWindowDimensions();

  // Derive orientation from the window (viewport) dimensions rather than the
  // physical screen so that on web/desktop a tall, narrow browser window renders
  // the portrait layout even though the underlying monitor is landscape.
  const orientation = windowDimensions.width > windowDimensions.height ? "landscape" : "portrait";

  return {
    orientation,
    windowDimensions,
  };
}
